import React, { useMemo, useState } from 'react';
import { connect } from 'react-redux';
import { setCurrentStep, setSelectedBan } from '../personalPricePlanBlockSlice';
import { PersonalPricePlanStep, stepBarList, subscriberError } from '../constant';
import SelectAccount from '../../../Shared/SelectAccount/SelectAccount';
import BtnNextStep from '../BtnNextStep';
import { isNullOrEmpty } from 'app/utilities/StringHelpers/StringHelpers';
import StepBar from '../stepBar';

const SELECT_ACCOUNT_TITLE = 'עם איזה חשבון נתקדם?';
const PAYMENT_LABEL = 'החיוב ירד מאמצעי התשלום בו מחוייב חשבונך:';


function mapProductsByBanToAccounts(productsByBan) {
    if (!productsByBan?.length) return [];
    return productsByBan.map((banItem) => {
        const accountType = banItem.productDescription ?? '';
        const accountInfo = [];
        if (banItem.paymentToken != null && banItem.paymentToken !== '') {
            accountInfo.push({
                labelText: PAYMENT_LABEL,
                value: `**** **** **** ${banItem.paymentToken}`,
            });
        }
        return {
            id: banItem.ban,
            type: accountType,
            products: banItem.products ?? [],
            disabled: subscriberError.isAccountTypeNotValid.checkFunction(banItem),
            disabledReason: subscriberError.isAccountTypeNotValid.errorBanMessage,
            tooltipId: `disabled-info-${banItem.ban}`,
            tooltipImage: require('../icons/info.svg'),
            tooltipText: subscriberError.isAccountTypeNotValid.errorBanDescription,
            accountInfo,
        };
    });
}

const SelectBan = (props) => {

    const accounts = useMemo(() => {
        const list = mapProductsByBanToAccounts(props.productsByBan);
        return [...(list ?? [])].sort((a, b) => {
            if (a.disabled === b.disabled) return 0;
            return a.disabled ? 1 : -1; // disabled accounts last
        });
    }, [props.productsByBan]);


    const onSelectBan = (ban) => {
        props.setSelectedBan(ban);
    };

    return (
        <div className="select-ban-container">
            <SelectAccount
                accounts={accounts}
                onSelect={onSelectBan}
                selectedAccountId={props.personalPricePlan.selectedBan}
                title={SELECT_ACCOUNT_TITLE}
            />
            <div className='select-ban-footer-container'>
                <StepBar steps={stepBarList} state={props.personalPricePlan} />
                <BtnNextStep 
                text={'לבחירת חבילה ומנויים'} 
                nextStep={PersonalPricePlanStep.SelectPackage} 
                canProceed={!isNullOrEmpty(props.personalPricePlan.selectedBan)}
                errorText={'כדי להמשיך יש לבחור חשבון'} />
             </div>
        </div>
    );
  }



const mapStateToProps = (state) => ({
  authentication: state.authentication,
  personalPricePlan: state.personalPricePlan,
  subscribersList: state.personalPricePlan.subscribersList,
  productsByBan: state.personalPricePlan.productsByBan,
  
});

const mapDispatchToProps = {
  setCurrentStep,
  setSelectedBan,
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectBan);


